import styled from 'styled-components'
interface DropdownListUiStylesInterface {
  showDate?: boolean
}
export const DropdownListUi = styled.div<DropdownListUiStylesInterface>`
  flex: 1;
  ${p => (p.showDate ? `flex:1` : 'width: 100%')};

  .rw-widget-picker {
    grid-template: 1fr / 1fr 2.9em;
  }
  .rw-picker-caret {
    background-image: url("${process.env.EDITOR_ASSETS_HOST}/assets/images/toolbox/clock.svg");
    background-position: center;
    background-repeat: no-repeat;
    svg {
      display: none;
    }
  }
`
